<div
  class="amigo-datetime"
  #origin
  [class.is-disabled]="disabled"
  [class.is-open]="isOpen"
  [class.is-invalid]="invalid">
  <div class="amigo-datetime-input-wrap">
    @if (guideRest) {
      <span class="amigo-datetime-guide" aria-hidden="true">
        <span class="is-typed">{{ text }}</span><span class="is-rest">{{ guideRest }}</span>
      </span>
    }
    <input
      class="amigo-datetime-input"
      type="text"
      autocomplete="off"
      [id]="inputId || null"
      [value]="text"
      [placeholder]="activePlaceholder"
      [disabled]="disabled"
      [attr.aria-invalid]="invalid"
      [attr.aria-describedby]="invalid ? errorId : null"
      [title]="formatHint"
      (focus)="onTextFocus()"
      (input)="onTextInput($event)"
      (blur)="onTextBlur()"
      (keydown.enter)="$any($event.target).blur()">
  </div>
  <button
    type="button"
    class="amigo-datetime-toggle"
    [disabled]="disabled"
    [attr.aria-label]="mode === 'time' ? 'Öppna tid' : 'Öppna kalender'"
    (click)="toggle()">
    <mat-icon class="amigo-datetime-icon">{{ mode === 'time' ? 'schedule' : 'calendar_today' }}</mat-icon>
  </button>
</div>
@if (invalid) {
  <span class="amigo-datetime-error" [id]="errorId">Ogiltigt format</span>
}

<ng-template #panel>
  <div class="amigo-datetime-panel" [class.is-time]="mode === 'time'">
    @if (mode !== 'time') {
      <mat-calendar
        [selected]="validValue"
        [startAt]="panelAnchor"
        [minDate]="min"
        (selectedChange)="onDay($event)">
      </mat-calendar>
    }
    @if (mode !== 'date') {
    <div class="amigo-datetime-clock">
      <div class="amigo-datetime-unit">
        <button type="button" (mousedown)="$event.preventDefault()" (click)="stepHour(1)" aria-label="Senare timme">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <span>{{ hourText }}</span>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="stepHour(-1)" aria-label="Tidigare timme">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <span class="amigo-datetime-colon">:</span>
      <div class="amigo-datetime-unit">
        <button type="button" (mousedown)="$event.preventDefault()" (click)="stepMinute(1)" aria-label="Senare minut">
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <span>{{ minuteText }}</span>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="stepMinute(-1)" aria-label="Tidigare minut">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>
    <div class="amigo-datetime-footer">
      @if (mode === 'datetime') {
        <button type="button" class="is-today" (click)="setToday()">Idag</button>
      }
      <button type="button" (click)="clear()">Rensa</button>
    </div>
    }
  </div>
</ng-template>
